module.exports = __webpack_public_path__ + "img/locked.svg";